/**
 * FIX-ADD-LOGS-OTHER-DAYS (chavi 2026-11-02) - the "תאריך" of a manual work log.
 * Today by default; any past day may be picked (never the future). A past day
 * has no "ending now", so its log is entered as start / end on that day.
 * Pure, unit-tested (`src/utils/__tests__/logDateModel.test.ts`).
 */
import { startFromDuration, toLocalInputValue } from './durationModel';

/** Today as YYYY-MM-DD (local time). */
export function todayLocalDate(now: Date = new Date()): string {
  return toLocalInputValue(now).slice(0, 10);
}

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

/** A valid YYYY-MM-DD that is not after today. */
export function isPickableLogDate(date: string, now: Date = new Date()): boolean {
  return DATE_RE.test(date ?? '') && date <= todayLocalDate(now);
}

const timeOf = (local: string): string | null => (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(local ?? '') ? local.slice(11, 16) : null);

/**
 * The start / end ("YYYY-MM-DDTHH:mm") moved to `date`, keeping their time of day.
 * With no end yet the day defaults to 09:00-10:00; with no start, the start is
 * the end minus `durationMinutes` (or one hour).
 */
export function timesOnDate(date: string, start: string, end: string, durationMinutes: number | null): { start: string; end: string } {
  const endHm = timeOf(end) ?? '10:00';
  const newEnd = `${date}T${endHm}`;
  const startHm = timeOf(start);
  const newStart = startHm && startHm < endHm ? `${date}T${startHm}` : startFromDuration(newEnd, durationMinutes && durationMinutes > 0 ? durationMinutes : 60);
  return { start: newStart, end: newEnd };
}

